/**
 * Subscriptions feature auto-registration and exports
 *
 * This module automatically registers the subscriptions feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { subscriptionsFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(subscriptionsFeature);

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';

// Export components (will be added later)
export * from './components';

// Export page components
export { default as SubscriptionsBundlingPage } from './SubscriptionsBundlingPage';
export { default as SubscriptionsPage } from './SubscriptionsPage';

// Export subscription flow container
export { SubscriptionFlowContainer } from './SubscriptionFlowContainer';
